<template>
  <v-img
    v-if="imgResp.src"
    :aspect-ratio="aspectRatio"
    :gradient="HERO_GRADIENT"
    :sizes="imgResp.sizes"
    :src="imgResp.src"
    :srcset="imgResp.srcset"
    alt="Background image for cross sell section"
    content-class="fill-height my-auto py-16"
    cover
    style="position: relative"
  >
    <v-container>
      <TitleParagraphRow class="text-white" :value="value" />

      <v-row
        v-if="value.items && value.items.length"
        class="my-8"
        justify="center"
      >
        <v-col
          v-for="item in value.items"
          :key="item.id"
          align="center"
          cols="12"
          sm=""
        >
          <v-hover v-slot="{ isHovering, props: p }" :disabled="platform.touch">
            <v-card
              v-bind="p"
              :href="item.href"
              :max-width="boxed ? 400 : undefined"
              :min-height="boxed ? 300 : undefined"
              :style="{
                borderColor:
                  outlined || (isHovering && item.href)
                    ? 'white'
                    : 'transparent'
              }"
              class="d-flex flex-column justify-center fill-height"
              color="transparent"
              elevation="0"
              rounded="0"
              variant="outlined"
            >
              <v-card-item
                v-if="typeof item.icon === 'string'"
                class="text-center"
              >
                <v-icon
                  :icon="`hdd:${item.icon}`"
                  :color2="isHovering && item.href ? 'red' : 'light-blue'"
                  color="white"
                  size="80"
                />
              </v-card-item>

              <v-card-item
                v-if="item.title"
                class="text-h6 text-center text-white"
              >
                <StyledText :value="item.title" />
              </v-card-item>

              <v-card-item v-if="item.href">
                <v-btn
                  :append-icon="mdiArrowRight"
                  color="white"
                  variant="text"
                >
                  More Info</v-btn
                >
              </v-card-item>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row v-if="value.cta" justify="center">
        <v-col align="center" cols="12" md="8">
          <div
            v-if="value.cta.title"
            class="text-body-1 text-white font-weight-bold mb-4"
          >
            <StyledText
              :value="value.cta.title"
              em-class="text-decoration-underline"
            />
          </div>

          <v-btn
            v-if="value.cta.action && value.cta.href"
            :append-icon="mdiArrowRight"
            :href="value.cta.href"
            :target="hrefTarget(value.cta.href)"
            class="text-capitalize"
            color="white"
            exact
            rounded="pill"
            size="large"
            >{{ value.cta.action }}</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>

<script setup>
import { toRef } from 'vue'
import { useDisplay } from 'vuetify'
import { mdiArrowRight } from '@mdi/js'
import { HERO_GRADIENT } from '#root/lib/consts'
import { useImgResponsive } from '#root/lib/img'
import { hrefTarget } from '#root/lib/utils'

const props = defineProps({
  boxed: {
    default: false,
    type: Boolean
  },
  outlined: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})

const { platform } = useDisplay()
const aspectRatio = 16 / 5
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.background_image
  }))
)
</script>

<style lang="scss">
.cross-sell-icon-hover img {
  filter: saturate(2) hue-rotate(180deg);
}
</style>
